// 产品详情页 in-box 模块
(function() {
    if (!has_variant()) {
        return ;
    }

    $(document).ready(function() {
        let variant_index = $('.hdt-product-form_item.is--selected').index();
        change_accessory_by_variant(variant_index);
    });

    $('.hdt-product-form_item').click(function() {
        let variant_index;
        const index = $(this).index();

        if(index > 0) {
          variant_index = index - index / 2;
        } else {
          variant_index = index;
        }
      
        change_accessory_by_variant(variant_index);
    });

    if (get_url_parameter('show-in-box')) {
      $('.product-in-box').show();
    }

    function has_variant() {
        if ($('.hdt-product-form__values .hdt-product-form_item').length <= 1) {
            return false;
        }
        return true;
    }

    function change_accessory_by_variant(variant_index) {
        $('.in-box-item.special-item').hide();
        $('.in-box-item.item-for-variant-' + variant_index).show();
    }

    function get_url_parameter(parameter) {
        var result = null,
            tmp = [];
        location.search
            .substr(1)
            .split("&")
            .forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameter) result = decodeURIComponent(tmp[1]);
            });

        return result;
    }
})();